import React from "react";
import "./legal.css";

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>

<p>
  This Privacy Policy describes how <strong>ZenQB EduTech LLP</strong> (“ZenQB”, “we”,
  “us”, or “our”) collects, uses, stores, shares, and protects personal data when
  you access or use the ZenQB website and web application (the “Platform”).
</p>

<p>
  By using the Platform, you consent to the collection and use of your information
  in accordance with this Privacy Policy.
</p>

<h2>1. Scope and Applicability</h2>

<p>
  This Privacy Policy applies to all users of the ZenQB Platform, including
  students, visitors, and registered account holders. It applies only to
  information collected through the Platform and not to information collected
  offline or through third-party websites not controlled by ZenQB.
</p>

<h2>2. Information We Collect</h2>

<p>
  We collect information to provide, operate, improve, and secure the Platform.
</p>

<h5>2.1 Information You Provide Directly</h5>

<p>This may include:</p>

<ul>
  <li>Name</li>
  <li>Email address</li>
  <li>Login credentials</li>
  <li>
    Academic preferences such as board, grade, subjects, and syllabus choices
  </li>
  <li>Feedback, queries, or communications sent to us</li>
  <li>Any content you voluntarily submit through the Platform</li>
</ul>

<h5>2.2 Information Collected Automatically</h5>

<p>When you use the Platform, we may automatically collect:</p>

<ul>
  <li>
    Device information (browser type, operating system, device identifiers)
  </li>
  <li>IP address</li>
  <li>
    Usage data such as pages visited, features used, time spent, and interaction
    patterns
  </li>
  <li>Cookies and similar tracking technologies (see Section 8)</li>
</ul>

<h5>2.3 Information Related to AI Features</h5>

<p>
  When you interact with AI-assisted explanations or tools:
</p>

<ul>
  <li>Queries and prompts submitted by you may be processed to generate responses</li>
  <li>Such data is used to provide the feature and improve system performance</li>
  <li>
    We do not use this data to identify you personally unless required for
    security, legal, or support purposes
  </li>
</ul>

<h2>3. Purpose of Data Collection</h2>

<p>We use collected information for the following purposes:</p>

<ul>
  <li>To create and manage user accounts</li>
  <li>To provide access to educational content and features</li>
  <li>To personalize learning experiences</li>
  <li>To improve platform performance, content quality, and user experience</li>
  <li>
    To communicate with users regarding updates, support, or important notices
  </li>
  <li>To maintain security, prevent misuse, and comply with legal obligations</li>
</ul>

<h2>4. Legal Basis for Processing (India)</h2>

<p>
  We process personal data in accordance with applicable Indian laws, including
  the Information Technology Act, 2000 and the Digital Personal Data Protection
  Act, 2023.
</p>

<p>Processing is based on:</p>

<ul>
  <li>User consent</li>
  <li>Performance of services requested by the user</li>
  <li>Compliance with legal obligations</li>
  <li>Legitimate interests such as platform security and improvement</li>
</ul>

<h2>5. Sharing of Information</h2>

<p>
  We do <strong>not sell</strong> personal data.
</p>

<p>
  We may share information only in the following circumstances:
</p>

<ul>
  <li>
    With service providers who assist in operating the Platform (e.g., hosting,
    analytics, email services), subject to confidentiality obligations
  </li>
  <li>With legal or regulatory authorities if required by law</li>
  <li>
    To protect the rights, safety, or integrity of ZenQB, its users, or the public
  </li>
  <li>
    In connection with a merger, acquisition, or restructuring (users will be
    notified where required)
  </li>
</ul>

<h2>6. Data Retention</h2>

<p>
  We retain personal data only for as long as necessary to:
</p>

<ul>
  <li>Fulfil the purposes outlined in this Privacy Policy</li>
  <li>Comply with legal, regulatory, or contractual requirements</li>
  <li>Resolve disputes and enforce agreements</li>
</ul>

<p>
  When data is no longer required, it is securely deleted or anonymized.
</p>

<h2>7. Data Security</h2>

<p>
  ZenQB implements reasonable administrative, technical, and organizational
  measures to protect personal data against unauthorized access, alteration,
  disclosure, or destruction.
</p>

<p>
  However, no system is completely secure. While we strive to protect user data,
  we cannot guarantee absolute security.
</p>

<h2>8. Cookies and Tracking Technologies</h2>

<p>
  We may use cookies and similar technologies to:
</p>

<ul>
  <li>Enable essential platform functionality</li>
  <li>Understand usage patterns</li>
  <li>Improve user experience and performance</li>
</ul>

<p>
  Users may control or disable cookies through their browser settings. Disabling
  cookies may affect certain features of the Platform.
</p>

<h2>9. Children’s Privacy</h2>

<p>
  ZenQB is intended for students and learners. If a user is under the age of 18,
  use of the Platform is expected to be under the supervision and consent of a
  parent or legal guardian.
</p>

<p>
  We do not knowingly collect personal data from children without appropriate
  consent. If we become aware of such data being collected improperly, we will
  take steps to delete it.
</p>

<h2>10. User Rights</h2>

<p>
  Subject to applicable law, users may have the right to:
</p>

<ul>
  <li>Access personal data held by ZenQB</li>
  <li>Request correction or updating of inaccurate data</li>
  <li>Request deletion of personal data, subject to legal obligations</li>
  <li>Withdraw consent where processing is based on consent</li>
</ul>

<p>
  Requests can be made by contacting us using the details provided below.
</p>

<h2>11. Third-Party Links</h2>

<p>
  The Platform may contain links to third-party websites or services. ZenQB is
  not responsible for the privacy practices or content of such third parties.
  Users are encouraged to review the privacy policies of external sites they
  visit.
</p>

<h2>12. Changes to This Privacy Policy</h2>

<p>
  ZenQB may update this Privacy Policy from time to time. Any changes will be
  posted on this page with an updated “Last updated” date. Continued use of the
  Platform after such changes constitutes acceptance of the revised Privacy
  Policy.
</p>

<h2>13. Contact Information</h2>

<p>
  If you have questions, concerns, or requests regarding this Privacy Policy or
  your personal data, please contact:
</p>

<p>
  <strong>ZenQB EduTech LLP</strong><br />
  Email: <strong>support@zenqb.com</strong><br />
</p>
      <p style={{ marginTop: "40px", color: "#64748b" }}>
        Last updated: February 2026
      </p>
    </div>
  );
};

export default PrivacyPolicy;